import { Component, signal } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GlobalMessageService, RoutingService, GlobalMessageType } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { ForgotPasswordService } from 'src/app/services/feature/forgot-pwd/forgot-password.service';

@Component({
  selector: 'app-backoffice-email-password-changer',
  templateUrl: './backoffice-email-password-changer.component.html',
  styleUrls: ['../kb-secure-password/kb-secure-password.component.scss'],
  standalone: false
})
export class BackofficeEmailPasswordChangerComponent {
  submitted = signal(false);
  tokenValue = '';
  subscription = new Subscription();


  constructor(
    private service: ForgotPasswordService,
    protected globalMessage: GlobalMessageService,
    protected routingService: RoutingService,
    private activatedRoute: ActivatedRoute) { }

  pwdchangeForm = new FormGroup(
    {
      password: new FormControl(
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(12),
          this.regexTester(new RegExp("(?=.*[0-9])"), {
            requiresDigit: true
          }),
          this.regexTester(new RegExp("(?=.*[A-Z])"), {
            requiresUppercase: true
          }),
          this.regexTester(new RegExp("(?=.*[a-z])"), {
            requiresLowercase: true
          }),
          this.regexTester(new RegExp("(?=.*[()~!@#$%^&*\\-_+=`|{}\\[\\]:;\"'<>,?/])"), {
            requiresSpecialChars: true
          })
        ])
      ),
      confirmPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(12)
      ])
    },
    {
      validators: this.compareBoth
    }
  );
  get pwdform() {
    return this.pwdchangeForm.controls;
  }

  get passwordValid() {
    return this.pwdchangeForm.controls["password"].errors === null;
  }

  get requiredValid() {
    return !this.pwdchangeForm.controls["password"].hasError("required");
  }

  get minLengthValid() {
    return !this.pwdchangeForm.controls["password"].hasError("minlength");
  }

  get requiresDigitValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresDigit");
  }

  get requiresUppercaseValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresUppercase");
  }

  get requiresLowercaseValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresLowercase");
  }

  get requiresSpecialCharsValid() {
    return !this.pwdchangeForm.controls["password"].hasError("requiresSpecialChars");
  }
  ngOnInit() {
    this.service.sendSuccessMsg(false);
    this.subscription.add(this.activatedRoute.queryParams.subscribe(param => {
      this.tokenValue = param?.['token'];
    }));

  }
  onSubmit() {
    const updateData = {
      token: encodeURIComponent(this.tokenValue),
      pwd: this.pwdchangeForm.controls['password'].value,
      checkPwd: this.pwdchangeForm.controls['confirmPassword'].value
    }
    this.subscription.add(this.service.resetPassword(updateData).subscribe((result) => {
      if ((result?.['status'] == 'error')) {
        this.globalMessage.add(
          { key: result?.['message'] },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
      else {
        this.globalMessage.add(
          { key: 'common.account_confirmation_profile_updated' },
          GlobalMessageType.MSG_TYPE_INFO
        );
        this.submitted.set(true);
        
      }
    }, (error) => {
      this.globalMessage.add(
        { key: 'common.updatePwd_token_invalidated' },
        GlobalMessageType.MSG_TYPE_ERROR
      );
      this.routingService.go({ cxRoute: '/' });
    }));

  }

  compareBoth(control: AbstractControl) {
    const password = control.get('password')?.value;
    const confirmPasswordControl = control.get('confirmPassword');

    if (!confirmPasswordControl) {
      return null;
    }

    const confirmPassword = confirmPasswordControl.value;

    // Check if confirm password is empty
    if (!confirmPassword || confirmPassword.trim() === '') {
      confirmPasswordControl.setErrors({ required: true });
      return { required: true };
    }

    // Check min length
    if (confirmPassword.length < 12) {
      confirmPasswordControl.setErrors({ minLength: true });
      return { minLength: true };
    }

    // Check password mismatch
    if (password !== confirmPassword) {
      confirmPasswordControl.setErrors({ mismatch: true });
      return { mismatch: true };
    }

    // Clear errors if all good
    confirmPasswordControl.setErrors(null);
    return null;
  }

  regexTester(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) {
        return null;
      }

      const valid = regex.test(control.value);

      return valid ? null : error;
    };
  }
  ngOnDestroy() {
    this.submitted.set(false);
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }
}
